(function externalLink(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.Pipe) {
    return;
  }

  const previousExternalLink = global.NewHomeSource.FullImageViewer.ExternalLink;
  const queryExternalLink = '[data-external-link]';
  const containerExternalLink = global.document.querySelector(queryExternalLink);
  const anchorLink = containerExternalLink.querySelector('a');
  const alertExternalLink = containerExternalLink.querySelector('[data-alert-link]');
  const hidden = 'hidden';

  /**
  * @private
  * hideLink: hidde the external link element from the DOM.
  */
  function hideLink() {
    containerExternalLink.setAttribute(hidden, true);
  }

  /**
  * @private
  * shouldBeIgnored: hides the external link element if the current element is not frame.
  *
  * @param {object} data information that was changed.
  */
  function shouldBeIgnored(data) {
    const isFrame = data.IsFrame;
    if (!isFrame) {
      hideLink();
    }
    return isFrame;
  }

  /**
   * @private
   * displayLink: show the link element to the DOM.
   *
   */
  function displayLink() {
    containerExternalLink.removeAttribute(hidden);
    containerExternalLink.setAttribute('data-item-id', this.Type);
    anchorLink.setAttribute('href', this.Source);
  }

  /**
   * @private
   * render: display the external link element.
   *
   */
  function render(data) {
    requestAnimationFrame(displayLink.bind(data));
  }

  /**
* @public
* toggleCopyAlert: copy current url to clipboard and show or hidde alert.
*
* @param {MouseEvent} event with the information related to click pressed.
*/
  function toggleAlertLink(event) {
    if (event && event.type !== 'mouseleave') {
      alertExternalLink.removeAttribute(hidden);
    } else {
      alertExternalLink.setAttribute(hidden, '');
    }
  }

  /**
   * @constructs NewHomeSource.FullImageViewer.ExternalLink
   */
  function ExternalLink() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  ExternalLink.update = function update(data, topic) {
    global.NewHomeSource.Pipe.conditionalPipe(shouldBeIgnored, render)(data, topic);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer.ExternalLink to the previous script.
   */
  ExternalLink.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.ExternalLink = previousExternalLink;
    return ExternalLink;
  };

  const eventsConfiguration = {
    externalLink: {
      callbacks: [toggleAlertLink],
      events: ['mouseenter', 'mouseleave'],
      elements: queryExternalLink,
    },
  };

  global.NewHomeSource.Event(eventsConfiguration);
  global.NewHomeSource.FullImageViewerState.add('onImageSet', ExternalLink);
  global.NewHomeSource.FullImageViewer.ExternalLink = ExternalLink;
}(window));
